import * as React from 'react'

function SvgGs(props) {
	return (
		<svg viewBox="0 0 750 375" width="1em" height="1em" {...props}>
			<defs>
				<linearGradient id="gs_svg__b">
					<stop stopColor="#d5dfff" offset={0} />
					<stop stopColor="#FFF" offset={1} />
				</linearGradient>
				<linearGradient id="gs_svg__a">
					<stop stopColor="#474747" offset={0} />
					<stop stopColor="#f50" offset={1} />
				</linearGradient>
				<linearGradient
					id="gs_svg__f"
					y2={102.99}
					xlinkHref="#gs_svg__a"
					gradientUnits="userSpaceOnUse"
					x2={228.97}
					gradientTransform="matrix(.74087 0 0 1.3286 40.513 .006)"
					y1={102.99}
					x1={215.83}
				/>
				<linearGradient
					id="gs_svg__c"
					y2={173.45}
					xlinkHref="#gs_svg__a"
					gradientUnits="userSpaceOnUse"
					y1={218.47}
					gradientTransform="matrix(1.5101 0 0 .65184 40.513 .006)"
					x2={110.94}
					x1={109.34}
				/>
				<linearGradient
					id="gs_svg__d"
					y2={337.23}
					gradientUnits="userSpaceOnUse"
					y1={316.38}
					gradientTransform="matrix(1.2315 0 0 .79928 40.513 .006)"
					x2={126.02}
					x1={125.91}
				>
					<stop stopColor="#b50000" offset={0} />
					<stop stopColor="#ffc500" offset={1} />
				</linearGradient>
				<linearGradient
					id="gs_svg__g"
					y2={1003.7}
					xlinkHref="#gs_svg__b"
					gradientUnits="userSpaceOnUse"
					y1={1040.4}
					gradientTransform="matrix(2.5627 0 0 .38409 40.513 .006)"
					x2={78.221}
					x1={117.6}
				/>
				<linearGradient
					id="gs_svg__h"
					y2={226.38}
					xlinkHref="#gs_svg__b"
					gradientUnits="userSpaceOnUse"
					y1={245.98}
					gradientTransform="matrix(.88634 0 0 1.1105 40.513 .006)"
					x2={255.03}
					x1={264.72}
				/>
				<linearGradient
					id="gs_svg__e"
					y2={147.35}
					xlinkHref="#gs_svg__b"
					gradientUnits="userSpaceOnUse"
					y1={149.38}
					gradientTransform="matrix(.55904 0 0 1.7607 40.513 .006)"
					x2={456.4}
					x1={407.87}
				/>
			</defs>
			<path fill="#00247d" d="M0 0h750v375H0z" />
			<path
				d="M0 0v20.963L333.073 187.5h41.925v-20.963L41.925.001H0zm374.998 0v20.962L41.925 187.5H0v-20.962L333.073 0h41.925z"
				fill="#FFF"
			/>
			<path
				d="M156.25 0v187.499h62.499V0h-62.5zM0 62.5V125h374.998V62.5H0z"
				fill="#FFF"
			/>
			<path
				d="M0 75v37.5h374.998V75H0zM168.75 0v187.499h37.499V0h-37.5zM0 187.499l125-62.5h27.95l-125 62.5H0zM0 0l125 62.5H97.05L0 13.976V0zm222.049 62.5l125-62.5h27.95l-125 62.5h-27.95zm152.95 124.999l-125-62.5h27.95l97.05 48.525V187.5z"
				fill="#cf142b"
			/>
			<g>
				<path
					d="M552.668 265.56s-2.08 5.49-3.266 5.49-5.49-2.373-5.49-2.373-3.117 5.049-4.75 5.34c-1.634.299-5.937-.738-5.937-.738s-4.155 0-4.304-.596c-.149-.59.15-1.776.15-1.776s-5.936 4.744-7.272 4.446c-1.336-.292-5.788-5.93-5.788-5.93l-.742 2.968-8.458-.298-7.42-4.75s-4.156 6.824-4.304 6.675-7.272 1.633-7.272 1.633l-.445-1.335-4.749-2.82s3.71-5.191 3.71-5.34-1.78-.745-1.78-.745l-2.672 2.23-5.49 3.558-5.491-2.522 2.374-4.452.297-3.267 4.304-6.526 52.682-51.202 25.97 47.935-3.857 14.395z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#6a4c2d"
				/>
				<path
					d="M590.096 268.665l13.712-.497-5.838-2.881 52.251-1.969-7.383-2.813-6.54-8.862-27.075-2.037s-2.037-1.546-5.347-.776c-.137-2.105-2.67-4.85-2.67-4.85l-16.668-1.267-10.408 7.104 7.03 18.003 8.936.845z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M121.32 150.76l2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-.67 20.8-.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c.11 1.45 1.55.45 1.55.45l9.79-.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z"
					stroke="#000"
					strokeWidth="1pt"
					fill="url(#gs_svg__c)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<path
					d="M590.102 170.97c1.05-.64 4.353-1.69 3.95-6.521s-4.59-5.397-6.924-5.235c-2.342.161-4.434 2.173-4.434 2.173l-7.732-4.912s3.87-24.405 7.974-25.933c3.9-2.813 4.59-4.03 4.59-4.67 0-.646-1.448-2.26-1.448-2.26l-25.212-2.981-23.84 2.82s-1.851 2.819-1.609 3.949c.242 1.124.323 2.335 4.59 5.638 4.725 3.633 7.973 24.486 7.973 24.486s-6.682 3.298-7.086 2.894c-.403-.397-2.415-.8-3.465-.64-1.043.162-4.508 1.932-4.508 6.521 0 4.596 3.465 7.253 3.465 7.253s22.79-2.657 26.175 3.62c3.304-7.57 24.964-4.911 27.541-6.203z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#656263"
				/>
				<path
					strokeLinejoin="round"
					d="M614.657 145.601s.254-2.651 2.142-3.912c1.894-1.26 14.507-1.894 17.537 0 3.024 1.894 4.16 11.228 4.16 11.228s1.895 3.279 2.019 5.676.379 4.036.379 4.036 10.091 13.122 10.215 24.977c1.137 8.073.882 29.64-2.266 37.837-.13 10.222-4.416 16.904-4.416 16.904s1.006 1.763.882 3.658c-.13 1.894-1.136 3.657-1.136 3.657l14.755 7.316-5.422-2.019s5.552 4.67 5.422 4.546c-.125-.13-6.18-2.906-6.18-2.906l3.658 3.658c-.124-.125-8.954-4.037-8.954-4.037s4.16 3.912 3.912 3.788c-.255-.124-6.688-3.155-6.688-3.155s4.036 4.292 3.912 4.037-5.8-2.521-5.8-2.521l.248 2.142s-4.54-.254-4.54-3.658c-2.272-1.26-3.781-3.03-3.781-3.03l-10.47-1.764-11.861-35.446 2.776-59.914.757-3.025-1.26-8.073z"
					strokeOpacity={0.979}
					stroke="#000"
					strokeWidth={0.77625}
				/>
				<path
					strokeWidth={0.822204}
					d="M606.733 337.074s-6.074-12.774-9.098-12.954c-2.732-5.21 9.495-47.792 33.149-50.22 13.004 1.068 1.068 14.99-7.483 10.706 1.068 3.745 5.34 9.104 5.34 9.104s-16.922 7.315-21.908 43.364z"
					stroke="#000"
					fill="#fb0"
				/>
				<path
					d="M525.307 338.937s5.03-14.544 8.08-14.724c3.055-.18-8.08-48.469-32.313-48.829-13.105 1.08-1.077 15.078 7.54 10.768-1.077 3.776-5.385 9.16-5.385 9.16s17.054 7.359 22.078 43.625z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#fb0"
				/>
				<path
					d="M547.539 248.104c-.062-.118-6.018 1.869-2.161 8.352.292-2.509 2.974-4.03 2.974-4.03s-4.086 4.85.236 8.936c.528-3.857 2.981-5.08 2.981-5.08s-3.036 8.936.056 10.743c.354-3.564 2.627-5.135 2.627-5.135s-2.745 7.998-.292 9.805c.292-3.03 2.335-4.378 2.335-4.378s-1.223 8.297 1.987 8.88c.062-2.924 2.397-5.78 2.397-5.78s-1.055 6.768 3.968 7.066c.063-2.57.994-5.49.994-5.49s2.28 7.18 5.608 6.012c-.056-2.1.056-6.074 0-6.074-.062 0 2.099 6.831 6.073 5.552-.584-1.931.23-4.21.23-4.21s2.105 4.266 5.9 2.862c.645-1.285-.175-3.794-.175-3.794s5.546 5.726 7.241 2.28-4.44-4.615-4.44-4.615h4.148s-1.34-3.502-6.949-4.266c1.926-.876 3.913-.23 3.913-.23s-1.168-4.384-6.893-4.85c2.223-.757 4.676-.23 4.676-.23s-.764-4.148-7.067-5.315c.993-1.112 3.676-.758 3.676-.758s-2.509-3.912-5.372-3.683c-2.862.236-28.733-2.626-28.671-2.57z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00713d"
				/>
				<g strokeWidth={1.25} strokeLinecap="round" stroke="#3ec26d" fill="none">
					<path
						d="M573.056 269.186s2.279 1.112 2.223 2.106M574.403 267.38s2.92 2.042 2.863 3.558M576.968 266.324s2.341 1.459 2.453 3.738M580.88 267.261s1.174 2.51.764 2.975M583.222 268.603c.173 1.987-.18 2.16-.18 2.16M554.426 256.046s2.745 1.751 2.515 4.204M554.252 258.151s1.285 1.224.994 2.043M557.643 256.108s1.807 2.51 1.223 4.26M560.735 257.741s.82 1.578.062 2.453M562.195 258.5s.993 1.576.117 2.104M561.09 263.697s2.564.584 2.918 2.509M562.604 261.946s2.69.173 2.981 3.036M566.169 260.952c.056 0 1.807 3.099 1.515 4.086M569.615 261.244s.696 2.98.174 3.912M571.832 262.411c0 .062.056 3.447.056 3.447M568.448 257.741s1.69.64 1.571 2.28M570.02 256.22s2.16 1.23 1.93 3.565M572.534 255.233s1.87 2.217 1.168 4.67M575.8 255.754s-.695 2.745-.41 3.857M577.788 257.623s-1.224.938-.584 2.106M567.163 268.31s.403 2.106 0 2.454M564.474 267.087s1.34 2.335.875 3.503M561.61 266.97s1.522 1.75 1.46 3.154M559.276 267.317s1.403 1.348 1.285 2.105M558.052 269.36s1.342 1.404 1.28 1.696"
						strokeWidth={0.77625}
					/>
				</g>
				<path
					d="M529.002 173.49c6.44-.118 12.88-.23 19.32-.347 0 0 12.76 0 14.14 4.142 2.415-5.521 13.45-5.173 13.45-5.173l20.003-.69c.118 16.097.23 32.193.348 48.29-3.907 18.735-17.475 31.962-32.423 37.595-17.823-5.75-29.087-20.81-32.764-37.943-.695-15.29-1.385-30.585-2.074-45.874z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M535.883 173.31l28.137 74.98 25.418-76.613c-7.887.51-24.803-1.242-26.902 5.95-3.254-6.434-21.052-3.839-26.653-4.317z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#006b00"
				/>
				<path
					d="M555.034 213.905c1.087.565 1.056-20.35 2.478-20.996.404-1.733.609-2.49 1.118-4.328-1.223-2.168-6.7-2.062-8.731-.218.913 2.919 1.316 3.894 1.316 3.894 2.745 4.44 2.199 22.12 3.82 21.648z"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={0.42786899999999994}
					fill="#ffc900"
				/>
				<path
					strokeLinejoin="round"
					d="M547.495 52.251s1.994-2.259 2.08-2.8c.094-.543 9.036-.904 14.365-10.842 2.98-5.24 0-2.168 0-2.168l-.18-2.53s3.707-3.523 2.353-5.421c-1.36-1.897-.907 2.44-3.074 2.35s-.994-4.699-.994-4.699-.18-.542-.813-.813c-.907.09-.633 1.717-1.447 1.897-.813.181-1.534-3.794-1.534-3.794s-1.354-1.807-2.534 3.885c.634 6.053 4.521 4.878 4.521 8.854 0 3.975-3.434 7.047-4.427 7.137-.994.09-.634-3.343-.634-3.343s-.54-1.626-.9-1.626 1.987-.361 1.627-4.879c-.814-5.42-1.447 1.265-2.894.994-1.447-.27-.36-4.969.18-5.51s-.633-2.802-3.794 2.98c-.274 2.801-.634-.722-1.267-.542-1.08 2.26-.9 3.885.633 5.963 2.26 2.078 3.708 4.156 3.615 5.24-.087 1.085-1.267 3.524-2.888 3.524-1.627 0 .087-2.982 0-3.976-.093-.993-2.8-4.607-2.8-4.607s-1.901-3.072-1.721-3.162c.18-.09-.18-.542-1.08 2.62-.907 3.162-1.994-2.078-1.994-2.078s-1.26 3.884 1.447 6.234c-2.074-.271-2.254.542-2.254.542 0 1.084 2.8 1.536 3.16 3.433.36 1.897-2.893 2.981-2.893 2.981s1.36 1.897 5.148-1.806c.093 2.348-1.44 3.975-1.44 3.975 1.26.572 2.253.511 2.433 1.987z"
					stroke="#000"
					strokeWidth={0.77625}
					fill="#cdad56"
				/>
				<path
					strokeLinejoin="round"
					d="M535.1 52.251s-1.689-2.507-1.763-3c-.081-.493-8.31.623-12.202-9.413-2.532-4.769 0-1.973 0-1.973l.154-2.302s-2.695-3.297-1.544-5.023.677 2.22 2.157 2.227c1.84-.082.844-4.275.844-4.275s.153-.493.69-.74c.766.083 1.082 2.556 1.772 2.72s2.117-2.91 2.564-3.542c.634-.09.61-2.548 1.609 2.631-.534 5.508-5.099 4.44-5.099 8.057s2.913 6.412 3.758 6.494c.844.082.54-3.041.54-3.041s.46-1.48.764-1.48c.31 0-2.683.574-2.373-3.536.69-3.848 2.217.248 3.447 0 1.23-.246-.143-4.069.211-4.653.08-.583 1.888-3.09 2.59 2.442.23 2.549 1.62-2.193 2.155-2.029.925 2.055-.404 4.8-1.708 6.691-1.92 1.89-2.789 3.962-2.708 4.949.075.986.528 2.212 1.913 2.212 1.379 0 .466-1.72.54-2.623s2.379-3.832 2.379-3.832c.453-.722.074-2.072.552-2.696.752.008 1.062-1.035 1.826 1.842.77 2.877 1.69-1.891 1.69-1.891s1.073 3.535-1.23 5.673c1.763-.247 1.918.493 1.918.493 0 .986-.838 1.397-1.148 3.123s.919 2.713.919 2.713-1.15 1.727-4.372-1.644c-.08 2.137 1.23 3.617 1.23 3.617-1.081.521-1.92.466-2.075 1.81z"
					stroke="#000"
					strokeWidth={0.682479}
					fill="#cdad56"
				/>
				<path
					d="M584.743 184.494c-1.683-1.527-1.882-.192-2.708-.534-.41-.167-.726-.546-1.08-.894-.304-.317-.67-.447-1.074-.615-.156.454-.305.9-.46 1.354s.429 1.205.416 1.882c-.118 1.006-.528 1.844-1.795 2.186.36-.714.566-.745.454-1.621-.05-.435-1.273-1.211-1.124-1.62.223-.665.608-1.43.323-2.094-.516.354-1.199.168-1.714.385-.441.193-.466 1.006-1.075 1.342-.62.292-1.993.149-3.142-.503.702-.528 1.28-.174 1.981-.702.348-.267.335-1.403.683-1.67.354-.268 1.193-.547 1.54-.814-.316-.36-.298-.925-.614-1.285-.311-.36-1.708-.286-2.025-.64-.633-.72-.51-1.664-1.143-2.379 1.634.584 1.398 1.38 1.808 1.317.77-.373 1.54-.44 1.943-.273.41.174 1.18 1.18 1.584 1.347.155-.453.379-1.024.528-1.478.155-.453-.683-1.235-.534-1.689.31-.9 1.068-1.701 1.372-2.608.112.876.255 1.608.366 2.478.056.434.913.664.97 1.099.055.44-.448 1.447-.398 1.888.472-.093 1.149-.031 1.614-.124.472-.094.783-1.18 1.249-1.273.937-.187 1.614-.13 2.564.05-.701.651-1.242.608-1.683 1.204-.347.267.137 1.143-.875 1.757-.38.224-1.379-.043-1.733.224.317.36.634.714.95 1.074.31.36 1.727.528 2.043.888.628.714.963 1.571.789 2.341zM541.478 185.233c1.683-1.527 1.882-.192 2.714-.534.403-.173.72-.552 1.074-.894.304-.317.67-.447 1.074-.62.156.453.31.906.46 1.36.155.453-.422 1.198-.41 1.875.112 1.012.522 1.844 1.789 2.192-.36-.714-.566-.752-.454-1.621.056-.435 1.273-1.211 1.124-1.627-.223-.658-.608-1.428-.323-2.093.522.36 1.199.174 1.72.385.435.199.466 1.012 1.069 1.348.627.292 2 .149 3.142-.503-.702-.534-1.28-.174-1.981-.708-.348-.261-.33-1.404-.683-1.665-.348-.267-1.186-.552-1.54-.82.316-.353.298-.925.614-1.285.317-.354 1.714-.28 2.025-.64.633-.713.515-1.657 1.143-2.378-1.634.584-1.391 1.379-1.801 1.323-.777-.373-1.547-.447-1.95-.273-.404.167-1.18 1.173-1.584 1.347-.155-.453-.372-1.024-.528-1.478s.69-1.235.534-1.689c-.304-.906-1.068-1.701-1.372-2.608-.112.87-.255 1.602-.366 2.478-.056.434-.913.664-.97 1.099-.049.435.454 1.447.398 1.882-.472-.094-1.149-.031-1.614-.118-.466-.1-.777-1.187-1.249-1.28-.937-.186-1.608-.13-2.564.05.701.658 1.242.609 1.683 1.211.347.267-.137 1.143.875 1.757.38.224 1.385-.043 1.733.224-.317.354-.634.714-.944 1.074-.317.36-1.733.528-2.043.882-.634.72-.969 1.577-.795 2.347z"
					fill="#ffc900"
				/>
				<path
					strokeLinejoin="round"
					d="M583.234 189.326c-1.528 1.186-11.37 3.676-11.476 12.227-.1 8.552 1.726 10.501-.1 10.719-3.552 0-4.06-9.526-3.961-13.75.105-4.222.204-3.57.204-3.57s2.435.646 2.236 2.708c-.205 2.055 2.434-5.093 1.522-7.036 1.62 1.62 3.757.975 3.757.863 0-.106-1.218-1.404-1.727-2.378s1.826.54 1.826.54.1-1.627-1.931-1.515c-2.64 0 .41-.87.41-.87s1.521 1.41 2.54-.105c-1.118-1.193-2.745-1.845-2.745-1.845s-1.423-2.701-3.348-3.241c-2.235-.547-1.93.968-4.47.757-.504.969-.504 1.08.508 1.404-1.726 1.192-.813 3.57-.813 3.57s2.745-1.186 2.64.758c-.1 1.95-1.622 1.627-2.64.435-.913-.54-1.217.54-1.217.54l1.422 1.515s-2.739-.105-3.453 1.733c1.522-.106 2.335.329 2.335.329s-3.148 1.403-3.453 2.161-.403-.863-.503-.863c-.105 0-3.049-1.087-3.049-1.087l-1.018 4.682s2.037 2.031 3.148 1.38c1.118-.647 3.149-2.597 4.366-2.056-3.552 2.707-7.104 6.6-9.036 7.147-.503-.434-2.23-2.167-2.943-1.304-.708.87-.199 1.95.714 1.845.913-.112-2.944.863-2.136 2.49.813 1.62.714 1.515 1.422 1.08.714-.434-.609-.54 2.03-1.298s2.54-1.515 2.54-1.515-.509 1.186-1.931 1.515c-1.422.323-2.534.323-2.23.758.305.429.913 1.186.709 1.62s2.943-2.272 3.757-.105c2.13-.112 3.552-2.707 2.54-4.223.099 1.621 1.117 2.168.502 2.925-.608.758 4.776-2.49 2.137-4.44.708 1.621.813 2.925.813 2.925s1.217-.112 1.522-.546c.304-.429-.609 1.192-.205 1.515.403.329 2.335 2.167 1.521 3.465-.503-.758-.608-1.95-1.217-1.838-.609.105-3.148 1.95-4.67 2.055s1.826 5.633 1.826 5.633-2.335-.33-2.64-.112-1.825-1.95-2.13-.646c-.509 1.621.51.969.51.969s-1.323-.646-2.03.112c-.715.757-1.423 1.515-.914 1.838.503.323 2.739.323 3.043.217s-2.54.218-2.738.54c-.205.324-.609 1.516 0 1.95s2.13-.217 2.229-.54c.105-.329.205 1.186.205 1.186s2.64.218 2.64-2.484c0-2.707.204 1.944.204 1.944s2.64.435 2.739-2.273c.105-2.701.304 1.845.304 1.845s1.726-.547 1.726-.975c0-.435-.099 5.409-1.316 7.036-1.932-1.305-3.149.863-3.149.863s.1 3.136-.105 3.893c-.199.758 1.322-.428 1.422-.757.105-.323 1.931-1.186 2.03-1.404.106-.217.61-1.298.61-1.298s-.405 1.516-1.112 1.733c-.715.211-1.423.969-1.118 1.62s1.422 1.081 1.825 1.733c.404.646 1.826-3.788 1.826-3.788l.106.975s1.825-.434 2.03-1.298c.2-.869-1.93-1.627-.205-3.03 1.727-1.41 0 1.298 0 1.298s.61 2.055 1.013 2.055c.41 0 1.422-3.9.41-4.868-1.019-.975 1.521 1.186 1.521 1.186s1.422-4.006-.1-4.546c-1.527-.54-2.235-.758-2.235-.758s.814-1.08.404-1.186c-.404-.111 2.136 2.379 2.54 1.727.41-.646 1.018-2.596-1.925-3.677-2.95-1.08-.106-4.117-.106-4.117s1.832 2.167 3.148.975c1.317-1.186-.099-1.186-.099-1.186s3.75-2.385 3.856-3.577c-.714-.105-1.93.112-1.93.112s2.135-1.41 1.626-3.683c-.813 1.193-1.931 1.193-1.931 1.193s1.832-1.838 1.521-3.571c-1.111.863-1.012 1.515-1.726 1.298-.708-.218-1.925-7.036.919-7.47 2.838-.43 1.317 3.359 1.416 3.359.105 0 4.266-1.733 0-4.546 1.018-.33 3.148 1.62 3.148 1.62s-.913-4.762-5.483-1.837c1.118-1.193 1.832-1.95 2.745-1.733s4.16-.112 4.16-1.08c-.807-.652-2.533.323-3.452 0-.913-.33 6.502-.87 5.893-4.546z"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={0.42786899999999994}
					fill="#ffc900"
				/>
				<path
					d="M481.3 118.54s12.25-6.43 18.37 1.54M504.57 132.32c-.31 0-4.29 3.98-5.21 3.98M512.84 145.18s11.32.92 18.67-10.41"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={1.25}
					fill="none"
				/>
				<path
					d="M525.08 141.81s.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9.3 2.14 2.76 3.37 7.66 0 9.49"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={1.25}
					fill="none"
				/>
				<path
					d="M519.26 218.97s-3.98 4.28-8.88 4.59"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={1.25}
					fill="#e80000"
				/>
				<path
					d="M523.86 199.37s-2.45-12.24-.92-15.31c.92-3.98 4.9-5.51 7.96-10.71M522.63 190.49s-3.06 7.35-16.53 4.9M526.31 172.12s.91 9.8-11.33 6.13M511.3 128.04s-4.9 4.28-3.06 10.1"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeLinecap="round"
					strokeWidth={1.25}
					fill="none"
				/>
				<path
					d="M567.087 191.703s2.132-.866 2.54-1.3c.404-.432 1.117-1.298 1.32-1.949.202-.647-1.423-1.623-.61-3.03.507-.649 1.216-.757 2.437 0 1.216.757-1.118-2.38-2.335-2.488-1.22-.109-2.033.865-2.334.649-.305-.217.1.866-.408.866s1.014.866.915 1.408c-.103.541 1.622 2.38 1.522 2.814-.103.432-2.54 2.92-3.047 3.03z"
					fill="#006b00"
				/>
				<path
					strokeLinejoin="round"
					d="M534.27 97.112c2.79-.636 3.24.07 2.75 2.449-1.31-.66-1.79-1.217-2.75-2.449z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#ffc900"
					strokeLinecap="round"
					strokeWidth={1.25}
					fill="#ffc900"
				/>
				<path
					strokeLinejoin="round"
					d="M514.71 233.52s-1.03 6.41 1.49 6.94c-.13-2.48.54-4.17 1.16-4.83-.54-.25-2.53-2.07-2.65-2.11zM509.03 225.63c-2.32-.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63.13 4.95-1.52.4-.46.29-1.81.16-2.39zM509.01 221.05s-3.65-.58-4.16 1.95c2.52-.32 3.27-.59 4.11-.06.24-.54.01-1.76.05-1.89z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeWidth={1.25}
					fill="#e80000"
				/>
				<path
					strokeLinejoin="round"
					d="M493.54 184.94s2.19.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06zM488.12 190.39c.09-.04 4.59-2.77 5.05-.16-.95.95-1.37 1.57-2.11 1.78-.58 0-1.74-1.78-2.94-1.62zM487.67 199.24c.08-.04 2.89-2.52 3.97-.87 1.07 1.66-.87 1.57-.87 1.57s-.99-.45-3.1-.7zM483.7 149.96c-.04 0-3.6-1.37-5.09 1.11 2.36.29 3.19 1.12 4.26 1.95-.29-1.04-.78-2.61.83-3.06zM476.8 168.52s.16-4.17 2.14-5.87c1.12.62 1.45 1.61 2.2 2.85-1.49.33-3.48.42-4.34 3.02zM486.3 165.54s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-.95 2.69-.99s0-2.77-.05-2.82z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeWidth="1pt"
					fill="#e80000"
				/>
				<path
					strokeLinejoin="round"
					d="M480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51.83-3.72-4.21-5.66-5.04-4.51z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeWidth="1pt"
					fill="#ffc900"
				/>
				<path
					d="M550.815 192.088c-.229.619.68 1.489 1.207 1.245.213-.637-.968-1.736-1.207-1.245z"
					fill="none"
				/>
				<path
					strokeLinejoin="round"
					d="M484.28 122.75s.62 2.94 3.47 2.15c-.45-2.27-2.44-3.97-2.44-3.97-.12.67.41 1.7-1.03 1.82zM486.18 131.27s1.57 1.69 4.67-1.78c-1.4.41-3.88-.83-3.88-.83s0 2.4-.79 2.61z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeWidth="1pt"
					fill="#e80000"
				/>
				<path
					strokeLinejoin="round"
					d="M480.46 118.86c-1.4 1.57.59 3.76 3.89 3.27.83-3.72-3.06-4.42-3.89-3.27z"
					transform="matrix(.3316 0 0 .35352 391.45 150.228)"
					stroke="#006b00"
					strokeWidth="1pt"
					fill="#ffc900"
				/>
				<path
					d="M144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73.28 3.73.28s5.46 2.01 7.04 1.58-1.15.15 1-1.15c2.16-1.29-4.31.29-4.88-2.44-1.01-1.72.14-3.88-2.15-3.16-1.58-2.01 1-3.44.43-5.6-1.58 1.15-2.45-.43-3.74 2.44-3.01-.57-.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z"
					fill="url(#gs_svg__d)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<path
					d="M500.91 329.237c2.836-.683 18.2 3.397 24.124 9.744-1.26-11.309-4.392-19.972-4.392-19.972s-9.155-2.614-10.412-1.353c-1.843 1.937-7.38 7.756-9.32 11.581zM496.227 276.999c-1.077.18-2.154.9-3.231 2.695-1.257 3.049-2.154 10.768-3.95 12.563s-3.41 1.974-3.41 3.595c0 1.615.18 5.384 5.026 6.819 4.847.18 12.567-7.72 12.567-7.72s3.95-4.309 5.564-8.973c-9.334 3.23-15.977-5.39-12.566-8.98z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#c01500"
				/>
				<path
					strokeWidth={0.822204}
					d="M631.237 327.436c-2.813-.677-18.35 3.379-24.231 9.688 1.248-11.24 4.36-19.86 4.36-19.86 1.086-.292 8.985-2.595 10.233-1.341 1.826 1.925 7.713 7.713 9.638 11.513zM635.59 275.502c1.069.18 1.447 1.584 2.323 3.372 1.242 3.03 2.528 7.452 4.31 9.234 1.782 1.789 3.384 4.428 3.384 6.036s-.372 3.776-5.185 5.204c-4.807.18-11.78-5.998-11.78-5.998s-3.919-4.28-5.521-8.924c9.265 3.217 15.264-5.055 12.47-8.924z"
					stroke="#000"
					fill="#c01500"
				/>
				<path
					d="M490.842 319.37s9.693 6.638 9.874 9.693c26.032-38.601 92.454-50.63 130.329-2.695 5.03-6.645 10.234-8.793 10.234-8.793-39.85-52.065-119.201-45.6-150.437 1.794z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#fb0"
				/>
				<g strokeWidth="1pt" stroke="#000" fill="#1e5aa6">
					<path
						d="M589.6 171.69l3.794-.094-6.776 8.583 8.13 9.488-15.991 20.146 15.09 18.158c-1.658 4.067-3.583 7.768-6.148 11.116l-8.67-9.582 15.718-19.6-12.916-14.636 7.768-23.58zM535.392 173.403l-4.067.094 7.588 8.215-8.036 10.03 16.712 18.164-13.824 18.518c1.658 4.068 4.037 8.582 6.595 11.923l8.222-10.39-16.891-18.79 12.377-15.718-8.676-22.046z"
						strokeWidth=".621pt"
					/>
					<path
						d="M554.184 222.19l-5.962 7.948 21.319 24.666c3.763-1.9 6.72-4.067 9.942-6.682l-11.116-12.83 4.521-13.283 6.502 7.496-20.325 25.933c-3.403-1.447-7.167-3.708-10.57-6.509l10.75-13.637-5.061-13.103zM547.589 209.813l3.887 4.88-2.534-6.594-1.353 1.714z"
						strokeWidth=".621pt"
					/>
					<path
						strokeWidth={0.801711}
						d="M575.416 214.129c.08-.094 3.136-4.161 3.136-4.161l-1.186-1.62-1.95 5.78z"
					/>
				</g>
				<g fontFamily="Timmons" fontSize={14} fontWeight="bold">
					<text
						y={362.397}
						x={-328.344}
						transform="matrix(.403 -.473 .473 .403 461.4 21.482)"
					>
						<tspan y={362.397} x={-328.344}>
							{'L'}
						</tspan>
					</text>
					<text
						y={384.266}
						x={-292.335}
						transform="matrix(.436 -.442 .442 .436 461.4 21.482)"
					>
						<tspan y={384.266} x={-292.335}>
							{'E'}
						</tspan>
					</text>
					<text
						y={451.681}
						x={-239.78}
						transform="matrix(.4737 -.33822 .35254 .46837 461.4 21.482)"
					>
						<tspan y={451.681} x={-239.78}>
							{'O'}
						</tspan>
					</text>
					<text
						y={429.958}
						x={-188.526}
						transform="matrix(.51446 -.3478 .3478 .51446 461.4 21.482)"
					>
						<tspan y={429.958} x={-188.526}>
							{'T'}
						</tspan>
					</text>
					<text
						y={451.479}
						x={-115.426}
						transform="matrix(.56 -.268 .268 .56 461.4 21.482)"
					>
						<tspan y={451.479} x={-115.426}>
							{'E'}
						</tspan>
					</text>
					<text
						y={453.046}
						x={-94.111}
						transform="matrix(.567 -.252 .252 .567 461.4 21.482)"
					>
						<tspan y={453.046} x={-94.111}>
							{'R'}
						</tspan>
					</text>
					<text
						y={454.982}
						x={-68.371}
						transform="matrix(.576 -.232 .232 .576 461.4 21.482)"
					>
						<tspan y={454.982} x={-68.371}>
							{'R'}
						</tspan>
					</text>
					<text
						y={445.666}
						x={112.016}
						transform="matrix(.619 -.052 .052 .619 461.4 21.482)"
					>
						<tspan y={445.666} x={112.016}>
							{'R'}
						</tspan>
					</text>
					<text y={430.793} x={180.225} transform="matrix(.62 .01 -.01 .62 461.4 21.482)">
						<tspan y={430.793} x={180.225}>
							{'R'}
						</tspan>
					</text>
					<text
						y={275.217}
						x={414.759}
						transform="matrix(.54 .307 -.307 .54 461.4 21.482)"
					>
						<tspan y={275.217} x={414.759}>
							{'R'}
						</tspan>
					</text>
					<text
						y={193.05}
						x={483.878}
						transform="rotate(39.8 201.03 648.008) scale(.621)"
					>
						<tspan y={193.05} x={483.878}>
							{'E'}
						</tspan>
					</text>
					<text
						y={414.028}
						x={309.116}
						transform="matrix(.59837 .11248 -.09645 .5911 461.4 21.482)"
					>
						<tspan y={414.028} x={309.116}>
							{'O'}
						</tspan>
					</text>
					<text
						y={459.272}
						x={105.058}
						transform="matrix(.56007 -.08172 .08475 .60547 461.4 21.482)"
					>
						<tspan y={459.272} x={105.058}>
							{'O'}
						</tspan>
					</text>
					<text
						y={455.835}
						x={-45.708}
						transform="matrix(.582 -.215 .215 .582 461.4 21.482)"
					>
						<tspan y={455.835} x={-45.708}>
							{'A'}
						</tspan>
					</text>
					<text
						y={144.724}
						x={518.35}
						transform="rotate(45.196 204.897 565.016) scale(.621)"
					>
						<tspan y={144.724} x={518.35}>
							{'A'}
						</tspan>
					</text>
					<text
						y={388.298}
						x={271.188}
						transform="rotate(11.357 122.69 2331.003) scale(.621)"
					>
						<tspan y={388.298} x={271.188}>
							{'A'}
						</tspan>
					</text>
					<text
						y={455.168}
						x={40.322}
						transform="matrix(.61 -.115 .115 .61 461.4 21.482)"
					>
						<tspan y={455.168} x={40.322}>
							{'M'}
						</tspan>
					</text>
					<text
						y={448.079}
						x={94.429}
						transform="matrix(.618 -.064 .064 .618 461.4 21.482)"
					>
						<tspan y={448.079} x={94.429}>
							{'P'}
						</tspan>
					</text>
					<text
						y={437.607}
						x={155.088}
						transform="matrix(.62 -.016 .016 .62 461.4 21.482)"
					>
						<tspan y={437.607} x={155.088}>
							{'P'}
						</tspan>
					</text>
					<text
						y={276.665}
						x={405.134}
						transform="matrix(.54 .306 -.306 .54 461.4 21.482)"
					>
						<tspan y={276.665} x={405.134}>
							{'P'}
						</tspan>
					</text>
					<text
						y={409.793}
						x={232.095}
						transform="rotate(6.586 44.083 4020.832) scale(.621)"
					>
						<tspan y={409.793} x={232.095}>
							{'I'}
						</tspan>
					</text>
					<text
						y={132.089}
						x={530.392}
						transform="rotate(46.59 205.751 546.6) scale(.621)"
					>
						<tspan y={132.089} x={530.392}>
							{'T'}
						</tspan>
					</text>
					<text
						y={218.519}
						x={464.158}
						transform="rotate(36.82 198.426 703.928) scale(.621)"
					>
						<tspan y={218.519} x={464.158}>
							{'T'}
						</tspan>
					</text>
					<text
						y={361.961}
						x={313.725}
						transform="matrix(.596 .175 -.175 .596 461.4 21.482)"
					>
						<tspan y={361.961} x={313.725}>
							{'M'}
						</tspan>
					</text>
					<text
						y={123.248}
						x={513.704}
						transform="rotate(47.66 206.381 533.067) scale(.621)"
					>
						<tspan y={123.248} x={513.704}>
							{'G'}
						</tspan>
					</text>
				</g>
				<g stroke="#fff700" strokeLinecap="round" strokeWidth="1pt" fill="none">
					<path
						d="M620.339 146.266s3.75-3.21 6.42-3.304M620.879 145.819c.087-.087 22.387-3.21 23.095-3.925M620.966 145.999c.087-.093 24.97-2.143 24.97-2.143M620.879 146.086s26.486-1.249 28.094.093M620.786 145.999s25.958.18 26.405.8M620.879 145.999l24.97 2.049M620.612 146.179c.087 0 25.418 2.23 27.914 5.44M649.861 156.164c-.087-.086-8.65-10.258-29.342-10.078M620.612 146.266s14.357.98 18.903 5.974M620.879 146.086s9.272-1.783 18.996 9.905"
						strokeWidth=".621pt"
					/>
				</g>
				<path
					d="M247.4 217.74s20.72.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56.81-5.48 1.42-37.58 1.02-39.2-.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z"
					stroke="#000"
					strokeWidth="1pt"
					fill="url(#gs_svg__e)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<path
					d="M601.162 153.42s8.955-8.7 14.128-7.695c2.645 0 .124 1.895.124 1.895s4.54.378 5.173 2.397c.124.881-2.149 1.136-2.149 1.136s1.895.379 2.019 2.018c.13 1.64-19.17.373-19.295.249z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#ff7000"
				/>
				<path
					d="M601.665 153.04s9.589-1.26 13.625-5.296M611.378 150.395s7.06-.254 7.06.758"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					strokeLinejoin="round"
					d="M636.479 253.575s6.054-1.391 7.694-3.534c1.012-.758 6.31 7.949-7.694 3.534z"
					stroke="#000"
					strokeWidth={0.77625}
					fill="#FFF"
				/>
				<path
					d="M634.84 203.497s.757 4.67-1.386 7.818c-1.136 1.261-4.545 3.41-4.545 4.925 0 1.51 1.26 3.527 1.012 5.297-.255 1.764-2.143 3.534-2.018 5.043 0 1.515 2.142 9.588 1.887 9.712M623.742 188.363s-4.794 1.64-5.807 6.434"
					stroke="#FFF"
					strokeLinecap="round"
					strokeWidth={0.77625}
					fill="none"
				/>
				<path
					d="M621.717 150.395s1.646 4.54 6.943.249c-3.41-4.664-6.943-.124-6.943-.249z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#c75b00"
				/>
				<path d="M625.632 150.204c0 .244-.254.442-.568.442s-.567-.198-.567-.442c0-.243.254-.441.567-.441s.568.198.568.441z" />
				<path
					d="M578.403 139.857s10.047 10.874 16.55 10.756c1.18 3.192-2.957 6.16-4.609 7.576-3.31-1.062-6.303.192-13.984-9.26.478-6.03 2.16-8.836 2.043-9.072zM591.996 114.564c1.298-4.018 3.9-7.21 6.142-7.564-.59-3.074 4.732-16.662 20.214-21.866.943 6.974-6.62 13.83-6.62 13.83s22.809-3.9 27.417-9.694c-.472 2.602-5.08 18.792-29.43 18.674 9.222 8.75-2.95 15.724-8.153 13.594 9.576-7.328-2.714-11.7-9.57-6.974z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M599.796 108.894c4.608-2.956 6.26-2.956 10.048-2.366-2.72.354-2.72.472-2.72.472s-.236.354 1.416 1.894c-1.888-.478-3.546-1.54-8.744 0z"
					stroke="#CCC"
					strokeWidth=".621pt"
					fill="#cccccd"
				/>
				<path
					d="M598.02 107s9.104-4.844 14.184-8.154"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M590.22 158.177s12.532 3.427 13.948-14.538c-2.72-7.8-6.502-24.585-.708-29.43-5.322-3.663-11.11.119-11.11.119-.354.826-5.086 7.563 1.298 19.381-15.127-4.018-8.98 10.284-8.98 10.284.59-2.248 8.626-4.372 10.638 7.092.826 2.838-5.44 7.21-5.086 7.092z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M604.286 143.757s13.24-7.092 12.88-23.753c-11.228.236-15.246 14.767-15.246 14.767l2.366 8.986z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M544.956 142.931s-9.806 8.508-15.364 5.788c-4.136 2.484-8.98-1.888-8.98-1.888s5.67 20.915 26.002 5.788c-.354-4.608-1.422-9.334-1.658-9.688z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M529.474 148.365c.826-4.372 4.254-6.502 6.974-2.366 3.664.714 7.328-14.296-5.676-11.818 3.664-19.617-7.325-26.945-7.325-26.945s-3.9 21.747-2.127 25.765c1.773 4.018-2.6-7.446-16.664-10.638-.237 16.432 15.719 24.114 15.719 24.114s4.491 4.136 9.099 1.888z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M530.772 134.063s-6.142 5.204-4.726 12.296M521.438 133.355s-1.418 5.08 1.655 12.29M520.492 147.303s2.837-4.608 8.982 1.298"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M521.674 115.39c0-.118-9.336 0-3.782 9.457-4.136 1.298-13.354-4.725-6.972-12.767-20.92-.472-29.429-10.514-29.429-19.736 6.146 6.384 20.801 3.782 26.001 7.682-6.382-5.906-5.082-14.066-5.082-14.066s17.847 5.322 21.037 21.158c-1.064 3.074-1.536 8.508-1.773 8.272z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M507.318 99.616c3.444 3.503 12.293 4.552 16.784 8.452"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					strokeWidth={0.588708}
					d="M511.392 109.956s7.326-.944 9.45 1.652c-2.867 0-3.823-.708-7.963.832 1.168-.596.849-1.658 1.486-1.658s-2.654-.826-2.973-.826z"
					stroke="#CCC"
					fill="#cccccd"
				/>
				<path
					d="M547.912 52.635s4.017-3.546 8.39-.355c-1.976 5.904-9.098 3.664-9.098 3.664s.236 2.955-.472 4.373c1.422 1.072 2.595 4.61 2.595 4.61s7.328-1.773 8.868 1.418c2.807-.388 4.844 0 4.844 0s5.676-1.418 7.682-1.418c2.012 0 8.39 1.654 8.98 2.836.596 1.181 2.72 9.1 4.142 8.982 1.415-.118-3.428 1.89-4.732-.118-1.298-2.01-.944 2.6-.944 2.6s4.017 4.254 4.49 5.2c.471.943-2.478 8.625-.237 13.947-1.968.18-2.123 2.242-2.123 2.242-.112 2.341-3.074 2.956-3.074 2.956l-.708-3.192-2.012 1.186.826-2.484s2.72-6.62 2.956-8.744c.236-2.13-2.484-5.911-4.608-5.911-2.13 0-3.664 6.737-3.664 6.737s-1.062 5.08-.708 5.552-1.422-1.652-1.422-1.652-.944 3.074-1.652 4.018-2.248 1.298-2.248 1.298-1.062-3.074-.708-4.254 5.794-5.788 5.322-9.097c-.478-3.31 0-2.484-.124-2.602-.118-.118-2.832-2.482-2.95-3.782-.118-1.3-3.546 1.655-8.036.709-1.378 2.402-1.54 8.388-1.54 8.388s-.472 7.21.472 8.042c.95.826-2.36 2.596-2.36 2.596l-2.366 3.192s-.826-2.006-.826-1.888-1.658 1.18-1.658 1.18l.95-2.366c-.062-1.788 2.298-6.676 2.298-10.812s.298-8.568.298-8.568-4.372-.237-4.254 4.252c.118 4.497-1.061 4.733-.825 6.03s1.415 4.962 1.061 6.03c-.354 1.062-1.77 1.416-1.77 1.416l-.353.59s-4.372 2.012-4.254 2.838-.118-2.366-.118-2.366L542 96.48s2.602-1.652 2.602-5.788-.597-4.725-.479-5.67c.118-.95.715-4.377.597-4.731-.118-.355-2.478.945-3.192.945-.708 0 1.304-2.482 1.54-4.255s-2.366 1.655-4.49-.354c.987-2.182 2.478-2.837 2.714-4.491s-1.652 1.418-3.31.236c.136-1.586 1.776-2.954 1.776-2.954s-1.348-.166-1.894 0c-1.062-.355 1.186-2.01 1.304-4.373s-1.304-3.31-1.304-3.428-2.36-2.127-2.714-2.954-.354-1.773-.354-1.773-3.906 2.836-8.514-3.191c4.223-3.604 8.75-.946 8.75-.946s1.18-3.31 6.614-3.073c5.44.237 6.501 3.31 6.266 2.955z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#923f00"
				/>
				<path
					d="M577.645 113.769c.093 0 10.035.298 10.135 5.614.1 5.31-3.05 3.937-3.149 3.937s-7.284-.888-7.284-.888l.298-8.663z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M567.995 112.29s12.401-.092 11.712 5.317c-.69 5.415-3.838 4.334-3.838 4.334l-6.005-.497-1.87-9.153z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#fffeff"
				/>
				<path
					d="M561.008 111.7l7.185.59s4.329.59 4.136 4.727c-.198 4.135-4.434 4.235-4.434 4.235l-6.986-.398.1-9.153z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M544.18 113.769c-.1 0-10.042.298-10.142 5.614-.093 5.31 3.056 3.937 3.155 3.937s7.284-.888 7.284-.888l-.298-8.663z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M553.823 112.29s-12.4-.092-11.712 5.317c.69 5.415 3.838 4.334 3.838 4.334l6.005-.497 1.87-9.153z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#00F"
				/>
				<path
					d="M560.816 111.7l-7.185.59s-4.335.59-4.136 4.727 4.428 4.235 4.428 4.235l6.986-.398-.093-9.153z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#FFF"
				/>
				<path
					d="M580.054 171.46s5.167-7.614 7.347-6.8c1.9.633.453 6.526-.453 7.073l-6.894-.273zM544.639 172.82c-1.627-2.267-3.987-8.52-6.16-6.8-1.907.633-.454 6.526.453 7.073l5.707-.273z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#5e0043"
				/>
				<path
					d="M548.06 157.76s10.067 6.204 13.37 6.366 13.774-8.055 13.774-8.055"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M549.03 133.442l1.93-2.416 9.67 4.913 9.824-4.354 1.931 2.019-10.954 7.731-12.402-7.893z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#5e0043"
				/>
				<path
					strokeLinejoin="round"
					d="M541.354 133.312c.782.987 7.03 8.582 8.16 14.866 1.124 6.285-.646-8.62-.646-8.62s7.731 3.789 7.973 6.205 3.695-.162 3.863-.578l-22.387-14.537 3.037 2.664zM579.551 132.877s-8.135 10.712-7.166 22.387c-1.677-5.589-.323-14.817-.323-14.817l-1.77 1.13s-1.85 7.893-4.191 9.098c-.392-.938-.317-1.286-.317-1.286s-2.497 3.217-2.98 3.54.16 10.874.16 10.874.839 7.65 1.801 7.57c-1.099.534-2.446 1.372-2.446 1.372l-1-20.418 2.285-2.298s3.062-3.701 3.304-7.328c-1.329 1.13-2.82 1.453-2.82 1.453s-.403 5.155-1.608 5.875c-1.21.727-1.242 2.074-1.242 2.074l-.285-6.738 18.598-12.488z"
					stroke="#474747"
					strokeWidth={0.77625}
					fill="#474747"
				/>
				<path
					d="M560.946 145.278l1.578 32.212"
					stroke="#000"
					strokeLinecap="round"
					strokeWidth={0.77625}
					fill="none"
				/>
				<path
					d="M541.136 160.66s3.702 2.18 5.074 8.781c12.078-.888 15.867 3.385 15.867 3.385s9.904-4.75 14.5-3.869c1.608-3.378 6.197-7.731 6.197-7.731"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M536.081 129.089l24.865 16.27 22.394-15.06s4.67-2.576 4.266-4.427c-.398-1.857-2.012-1.13-2.82-.807-.8.323-23.436 16.35-23.436 16.35l-24.082-15.226s-1.77-.56-2.093.565c-.323 1.13.664 1.77.906 2.335z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#b4b6b9"
				/>
				<path
					strokeLinejoin="round"
					d="M580.551 124.866s-6.365-2.701-6.365-.36c0 2.335.18 2.577 1.205 4.08 1.018 1.496-.783 2.459-.783 2.459s-.242-.658-.602-1.683c-.36-1.018-3.782-1.739-4.08-2.937-.298-1.205.72-3.124-1.323-3.36-2.037-.242-4.018.839-4.44 3.18s-3.061 7.8-3.061 7.8l.36-12.42c4.483.316 12.805 1.297 19.207 2.036-1.919-.298.72.125.665.783-.18.54-.845.596-.783.422zM558.04 121.742c-1.136 0-6.843.659-8.284 1.503-1.44.839 2.341 2.155 1.863 3.298s-.54 3.421-2.341 2.943c-1.801-.484-7.862-3.483-8.042-4.502s-1.441-1.08-1.441-1.08 17.407-2.342 18.245-2.162z"
					stroke="#474747"
					strokeWidth={0.77625}
					fill="#474747"
				/>
				<path
					d="M560.785 120.314l-.044 15.264M549.03 102.33s-6.975 11.32-7.111 11.669"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79"
					stroke="#000"
					strokeWidth="1pt"
					fill="url(#gs_svg__f)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<path
					d="M573.615 101.361s-6.558 9.253-6.353 9.942"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path d="M540.013 57.364c-.149.517-.985.717-1.867.447s-1.478-.909-1.33-1.426c.15-.518.985-.718 1.868-.448s1.477.91 1.329 1.427zM542.664 57.181c.148.517.984.718 1.867.447s1.477-.908 1.329-1.426c-.149-.517-.985-.718-1.867-.447s-1.478.909-1.33 1.426z" />
				<path
					strokeLinejoin="round"
					d="M619.438 248.849s-2.434.46-2.353.683c.074.23-7.073.46-7.223.23-.155-.23-1.068 1.217-1.068 1.217l1.143-.683s1.745 1.82 2.28 1.67-.23.683-.075.838c.149.15.683-.304.683-.304l11.811-.199-5.198-3.452z"
					stroke="#000"
					strokeWidth=".621pt"
					fill="#ff7000"
				/>
				<path
					strokeLinejoin="round"
					d="M623.841 252.525l-9.65.28s-2.428 2.204-2.584 2.732c-.149.534 1.596.683 1.596.683l.535 1.826 1.217-.454s8.203 1.218 15.736-.46c3.8-1.328 4.465-2.924 1.8-3.893-2.657-.969-8.575-.677-8.65-.714z"
					stroke="#000"
					strokeWidth={0.77625}
					fill="#ff7000"
				/>
				<path
					d="M208.37 403.93l27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88.68.68 2.38-6-.23s6.68 2.6 6.91 3.74z"
					stroke="#000"
					strokeWidth="1pt"
					fill="url(#gs_svg__g)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<path
					d="M239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l.45 25.11s15.99-8.67 23.77-6.67c-.45-7.78-.45-17.77-1.33-23.11z"
					stroke="#000"
					strokeWidth="1pt"
					fill="url(#gs_svg__h)"
					transform="matrix(.621 0 0 .621 461.4 21.482)"
				/>
				<g stroke="#000" strokeWidth="1pt" fill="none">
					<path
						d="M514.231 223.71l-40.959 40.664M532.486 224.009l-33.244 43.78M531.002 212.582l-44.374 53.723M485.292 265.56l4.304-5.043M539.46 239.59l-17.216 23.747M521.502 266.454l.446 9.048M547.322 247.899l-18.252 22.859M544.061 268.975l7.421-12.171M546.88 254.432l-8.904 10.09M544.21 244.936l-6.085 7.415M536.342 234.1s-18.55 27.156-18.253 29.386M534.411 230.542c-.44.292-16.025 20.921-16.025 20.921M517.496 257.99l-2.82 3.415M511.114 266.603l-4.303 5.639"
						strokeWidth=".621pt"
					/>
				</g>
				<path
					d="M512.205 161.207s-1.257 3.95 0 5.924c1.256 1.975 9.155 17.953 9.155 17.953s5.388-6.644 7.363-6.824c1.974-.174 1.074 17.239 1.074 17.239s-3.23 3.049-5.204 2.869c-1.976-.18 4.844 6.824 4.664 12.749s-8.974 35.366-12.205 35.9c-3.232.54 1.436-5.384 1.256-6.999s-1.077-.54-1.795-2.335 1.078-4.49.718-6.284c-.359-1.795-1.975-1.435-2.154-2.69-.18-1.26 1.077-1.614.898-3.055-.18-1.434-2.155-1.074-1.975-2.335.18-1.254.359-.714.18-3.049s-.539 1.615-2.514 1.795-3.59 4.67-3.59 4.67-3.95 5.564-7.9 3.049c2.334 5.03.54 7.185-.358 7.359-.898.18.717 3.95-1.437 4.13s1.616 8.439-.897 9.16c2.692 1.254.538 2.868.538 2.868s-6.222.522-4.847 8.62c-18.311-6.465-27.287-17.593-27.108-28.902.18-11.314 3.77-21.542 12.567-25.312 2.513-9.34 6.822-19.393 6.822-19.393s-.718-4.13-.18-6.819c.54-2.695 3.052-5.384 3.052-5.384s-.36-6.465-.179-9.694c.18-3.235 1.436-4.67 1.615-6.464s-.538-10.955 1.257-12.57 5.206-1.434 7.001-2.508c1.796-1.08 4.13-3.056 6.463-2.876s4.308 1.795 4.308 1.795 8.798 0 9.336 3.41c.538 3.415-1.795 4.67-1.795 4.67s1.257 4.85-4.13 9.333z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#8a9396"
				/>
				<path
					d="M504.394 148.77c.282.52-.36 1.413-1.433 1.994s-2.172.63-2.454.11c-.281-.521.36-1.414 1.434-1.995s2.172-.63 2.453-.11z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#cecfcf"
				/>
				<path d="M502.904 149.676c0 .329-.299.595-.667.595-.368 0-.667-.266-.667-.595 0-.328.299-.594.667-.594.368 0 .667.266.667.594z" />
				<path
					d="M516.03 155.618s2.18 9.737-.427 16.456M516.7 151.358s4.255 5.626 3.706 12.625M517.112 150.122c.138 0 3.568 3.018 3.43 5.074M517.936 148.886s2.333 1.646 2.881 3.292"
					stroke="#2b2b2b"
					strokeWidth={0.388125}
					fill="none"
				/>
				<path
					d="M516.838 147.924s-8.37 13.587-7.273 22.095"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M517.387 147.514s-11.115 6.589-13.173 28.131"
					stroke="#2b2b2b"
					strokeWidth={0.388125}
					fill="none"
				/>
				<path
					d="M516.152 151.495l-4.391 3.29"
					stroke="#000"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					d="M500.097 176.881s6.175-25.66 17.153-29.367"
					stroke="#2b2b2b"
					strokeWidth={0.388125}
					fill="none"
				/>
				<path
					d="M521.503 185.525s5.903-7.408 7.275-7.135.957 17.152.957 17.152-4.39 3.291-5.347 3.155c-.963-.137 4.937 7.961 4.8 10.98s-.273 3.017-.273 3.017 0-1.782-1.372-4.664-.553-6.179-9.47-13.45c-2.196-4.528 4.391 2.744 5.762 1.645 1.373-1.093-2.469-10.563-2.332-10.7z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#2b2b2b"
				/>
				<path
					d="M511.014 143.794s-2.48.677-2.82 1.69c-.338 1.018-1.803 2.03-2.592 1.688-.79-.335-2.256-1.577-2.256-1.577"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path
					strokeLinejoin="round"
					d="M496.919 152.476s-3.721 3.72-1.917 4.173c1.804.447 3.721-2.931 3.721-2.931s0 5.75 1.579 4.844c1.579-.9 6.201-4.167 6.201-4.167s1.579-.118 1.917 0c.339.111 4.285 3.49 6.878 2.254-1.465 3.831-3.157 4.285-3.157 4.285s-2.706 3.496-6.201 2.701c-3.496-.789-4.398-2.254-4.398-2.254s-2.932.23-3.834-1.124c-.902-1.354-1.24-2.143-1.24-2.143s-1.691 1.69-2.143.9c-.45-.788 0-5.414 2.594-6.538z"
					stroke="#2b2b2b"
					strokeWidth={0.77625}
					fill="#2b2b2b"
				/>
				<path
					d="M518.005 147.29s-6.878-2.03-9.246 1.354c-2.368 3.378-1.804 5.297-.564 5.633"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="none"
				/>
				<path d="M519.066 147.098c0 .81-.58 1.468-1.297 1.468s-1.296-.657-1.296-1.468.58-1.468 1.296-1.468 1.297.657 1.297 1.468z" />
				<path
					d="M499.048 164.647s2.805 4.316 6.149 5.502-2.32 2.211-5.664-.05c-2.427-3.29-1.78-5.663-1.78-5.663s.647-.652 1.295.211zM523.05 190.108s-7.875-10.948-10.14-11.544c-2.266-.59 1.725-1.074 4.153 1.242 2.427 2.316-.647-3.776-.647-3.776l6.634 14.078z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#2b2b2b"
				/>
				<path
					strokeLinejoin="round"
					d="M498.293 253.376c3.02-.807 16.18 7.551 19.147 9.656 2.967 2.1 9.171.752 9.171.752s-2.863 1.726-4.64 2.16c-1.78.43 5.286.43 5.286.43s-16.828 4.638-33.926-4.366c-1.565-7.011 3.667-8.576 4.962-8.632z"
					stroke="#2b2b2b"
					strokeWidth={0.77625}
					fill="#2b2b2b"
				/>
				<path
					d="M517.548 192.803s-2.211-.428-3.344-1.726c-1.132-1.292-2.75-4.477-4.423-5.825-1.672-1.347-10.032-5.93-13.052-5.608s-3.938-.322-4.316-.701-1.617.161-1.402 1.726c.216 1.565-2.32 5.018-1.402 6.632.917 1.621 5.232 8.198 6.095 8.415.863.217.324 3.832.324 3.832s3.829 3.88 4.8 4.098c.97.217 1.941.92 1.834 1.832-.108.92-4.208 5.937-4.208 5.937s-4.422 2.316-4.476 3.614c-.054 1.292 1.078 3.987 4.585 4.85 3.505.863 12.944.162 13.43-.646.485-.807 1.24-5.663.916-6.148s-2.643-1.943-3.83-1.726c-1.185.217-2.264 1.186-2.157 1.403.108.218-1.671 1.13-1.671.267s3.505-4.744 3.829-4.421c.324.323 5.286.807 6.203 3.291.917 2.478.917 4.26 3.505 3.993 2.59-.273 6.202-2.645 6.525-7.607s-2.91-8.309-3.72-8.793-3.506-2.106-3.721-2.857c-.216-.758-.755-3.235-.324-3.832z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#2b2b2b"
				/>
				<path
					d="M470.893 214.706s8.36-2.16 10.517-2.105c2.158.05 10.302 3.825 12.676 6.148 2.373 2.316 7.227 7.818 10.41 7.334 3.182-.485 4.099-1.13 4.099-1.13l-1.241 2.372s-2.589.702-3.883.379c-1.295-.323-3.83-1.137-6.365-3.615-2.535-2.484-10.356-9.172-16.99-8.687-6.634.49-10.464 7.017-10.464 7.017s.054-3.186.324-3.887-1.402 1.509-1.402 1.509l2.319-5.335z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#2b2b2b"
				/>
				<path
					d="M501.69 221.177c.055.05 2.104.59 5.556.59s5.286-1.51 5.286-1.51l-.216-1.347.54-1.888s2.642 2.696 2.588 3.236-1.078.758-1.078.758l-.378-1.298-.916 1.136s-5.017 3.987-7.767 3.397c-2.751-.596-5.286-2.372-4.585-2.807.701-.428 1.079-.267.97-.267zM489.5 228.244s-3.02-.056-4.368.59-1.834 1.46-2.75 1.347c-.917-.105-1.619-1.291-1.35-1.776.378-.757 2.158-1.726 5.556-1.459 3.398.273 2.913 1.298 2.913 1.298zM500.073 236.441c0-.161-.216-4.421-1.888-6.148-1.672-1.726-3.722-1.726-4.639-1.515-.917.217 3.398 2.105 3.83 3.347s1.834 4.695 1.456 5.558c-.378.857-1.079-2.428-3.722-3.347s-6.31-.429-5.555.758 3.722.105 5.232 2.639 2.643 5.235 2.643 5.235l.485-1.838 1.349-.373.161-3.509.648-.807z"
					stroke="#2b2b2b"
					strokeWidth=".621pt"
					fill="#2b2b2b"
				/>
				<path
					strokeLinejoin="round"
					d="M497.915 250.246l-2.75-5.502s-.864-3.503-3.183-4.477c-2.319-.97-5.394-.808-5.448.378s4.963 2.695 5.286 3.348c.324.645.162 1.726-.27 1.776-.43.055-2.642-.808-3.775-.54-1.133.273-1.78 1.726-3.452 1.297-1.672-.435-3.075-5.769-2.427-6.31.647-.54-1.24.97-1.618-.434s.54-5.769-.108-6.31c-.647-.54-3.775-2.427-3.83-2.806-.053-.373.162-21.462 17.8-3.987-7.552-8.955-10.518-7.986-11.92-8.036-1.025 0-7.875.59-9.601 9.328-1.726 8.737-3.776 3.291-3.776 3.291s-.377 3.776 1.457 4.856c1.833 1.075-.864 4.204-.864 4.204s-3.29-8.035-2.804-11.544c-.647 2.807-.593 9.762 3.56 17.37 4.854 5.123 9.439 9.873 21.628 15.208 6.419-9.812 6.095-10.998 6.095-11.11z"
					stroke="#2b2b2b"
					strokeWidth={0.77625}
					fill="#2b2b2b"
				/>
				<path
					strokeLinejoin="round"
					d="M486.373 250.302s3.56.428 4.53 2.267c.971 1.831 1.403 4.638 1.403 4.638.593-1.186.862-2.21 2.05-3.074s2.05-.975 1.995-1.62-3.776-4.583-5.663-4.8-5.178 2.049-5.178 2.049-.593.863.863.54z"
					stroke="#2b2b2b"
					strokeWidth={0.77625}
					fill="#8a9396"
				/>
				<g strokeWidth={1.25} strokeLinecap="round" fill="none">
					<path
						d="M494.504 259.58s9.225 4.204 24.42 4.477"
						stroke="#8a9396"
						strokeWidth={0.77625}
					/>
					<path
						d="M525.3 216.755s-.788 7.744-6.744 23.02"
						stroke="#2b2b2b"
						strokeWidth={0.77625}
					/>
					<path
						d="M524.115 221.519s-1.788 5.557-6.75 9.724"
						stroke="#2b2b2b"
						strokeLinecap="butt"
						strokeWidth=".621pt"
					/>
				</g>
			</g>
		</svg>
	)
}

export default SvgGs
